import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "jiffy-api";
import { objNamesToCamelCase, objNamesToSnakeCase } from "common/utils/helpers/cases";
import type { designLab } from "common/utils/models";

export function usePdpDeliveryEstimates() {
  const queryClient = useQueryClient();

  return useMutation<
    designLab.getPdpDeliveryEstimates.Response,
    Error,
    designLab.getPdpDeliveryEstimates.Request
  >({
    mutationFn: async params => {
      const { slug, ...payload } = params;
      const snakeCasePayload = objNamesToSnakeCase(payload);

      // Call the API with the slug in the path and payload wrapped under delivery_estimate key
      const response = await api.designLab.getPdpDeliveryEstimates(
        { slug },
        { delivery_estimate: snakeCasePayload }
      );

      return objNamesToCamelCase(response);
    },
    onSuccess: data => {
      // Update the delivery date cache with new estimates
      if (data.compositionDates) {
        queryClient.setQueryData(["deliveryEstimates"], data.compositionDates);
      }
    }
  });
}
